export default "__VITE_PUBLIC_ASSET__0d577cd9__"